import React, { useState } from 'react';
import { Window } from '@progress/kendo-react-dialogs';
import { Button } from '@progress/kendo-react-buttons';
import { Icon } from '@progress/kendo-react-common';
import { ITicket } from '../../../../types/Ticket/ITicket';
import { useGetTenantQuery } from '../../../../redux/api/BaseApi';


const DashboardPopup: React.FC<ITicket> = (details) => {
    const [visible, setVisible] = useState(false);
    const { data: tenant } = useGetTenantQuery()

    const toggleWindow = () => {
        setVisible(!visible);
    };

    if (!details?.Dashboard_Url) return <></>;

    return (
        <div>
            <Button title='Dashbaord' fillMode='flat' icon="graph" onClick={toggleWindow}>
            </Button>
            {visible && (
                <Window minimizeButton={() => null} className='dashboard cool-window' title="Dashboard" onClose={toggleWindow} initialHeight={800} initialWidth={1000}>
                    <iframe src={tenant.Tenant_Url + details?.Dashboard_Url} width="100%" height="100%" frameBorder="0" />
                </Window>
            )}
        </div>
    );
};

export default DashboardPopup;